import { systemEngineEnvironment } from "services/environment/systemEngine";

export type StartEngineOptions = {
  signal?: AbortSignal;
};

export const startWorkspaceEngine = async (
  name: string,
  options?: StartEngineOptions
) => {
  return systemEngineEnvironment.execute(`START ENGINE "${name}"`, {
    signal: options?.signal,
  });
};
